import React from "react";

import { Card, Typography } from "@material-ui/core";

import imgEdit from "../../../../assets/system-edit.png";
import imgAlert from "../../../../assets/system-alert.png";
import imgSearch from "../../../../assets/system-search.png";

import ListaVaziaCss from "./ListaVaziaCss";
const useStyles = ListaVaziaCss();

export default function ListaVazia(props) {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <div className={classes.img}>
                {props.tipoMensagem == "Edit" && (
                    <img className={classes.img} src={imgEdit} width="60" />
                )}
                {props.tipoMensagem == "Alert" && (
                    <img className={classes.img} src={imgAlert} width="60" />
                )}
                {props.tipoMensagem == "Search" && (
                    <img className={classes.img} src={imgSearch} width="60" />
                )}
            </div>
            <div className={classes.obj2}>
                <Typography className={classes.Description} color="textPrimary" gutterBottom>
                    <a className={classes.title}>{props.text}</a>
                    <br />
                    <a className={classes.subTitle}>{props.textDescription}</a>
                </Typography>
            </div>
        </Card>
    );
}
